import {Component, Input} from '@angular/core';

@Component({
    selector: 'scitis-page-summary',
    templateUrl: './page-summary.component.html',
    styleUrls: ['./page-summary.component.scss'],
    standalone: false
})
export class PageSummaryComponent  {

  @Input()
  itemsCount: number = 0;

  @Input()
  singleItemText: string | undefined = '';

  @Input()
  multipleItemsText: string | undefined = '';


}
